import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore, type AppConfig } from './store';
import { api } from '@/api/client';

interface LoginResponse {
  access: string;
  expires_in: number;
  user: { userid: number; username: string; memberid: number };
  config?: AppConfig;
}

export function useAuth() {
  const navigate = useNavigate();
  const access = useAuthStore((s) => s.access);
  const user   = useAuthStore((s) => s.user);
  const setSession = useAuthStore((s) => s.setSession);
  const logoutStore = useAuthStore((s) => s.logout);

  const login = useCallback(
    async (username: string, password: string) => {
      const data = await api<LoginResponse>('/auth/login', {
        method: 'POST',
        body: { username, password },
      });
      setSession(data.access, data.user, data.config ?? null);
    },
    [setSession],
  );

  const logout = useCallback(async () => {
    try {
      await api('/auth/logout', { method: 'POST', offlineQueue: false });
    } catch {
      /* ignore */
    }
    logoutStore();
    navigate('/login', { replace: true });
  }, [logoutStore, navigate]);

  return {
    user,
    isAuthenticated: Boolean(access && user),
    login,
    logout,
  };
}
